import React, { useEffect, useState } from "react";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import styles from "./style.module.scss";
import cx from "classnames";
import SelectInput from "../SelectInput";
import { DYNAMIC_DATA_SPLITTER } from "utils/Constants";

const DynamicTypeInput = (props) => {
  const { id, className, isDisabled, inputProps, onChange,
    value = "", options, dynamicType = "text", inputErrors } = props;
  const [dataType, setDataType] = useState("");
  const [inputValue, setInputValue] = useState("");

  const DATA_VALUE_INDEX = "0";
  const DATA_TYPE_INDEX = "1";

  useEffect(() => {
    if (value) {
      const data = value.split(DYNAMIC_DATA_SPLITTER);
      if (data.length === 2) {
        setDataType(data[DATA_TYPE_INDEX]);
        setInputValue(data[DATA_VALUE_INDEX]);
      }
    }
  }, [value]);

  const triggerOnChange = (newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  }

  const getNewValue = (value, dataType) => {
    const parseDataType = dataType.value || dataType;
    return `${value}${DYNAMIC_DATA_SPLITTER}${parseDataType}`;
  }

  const onDataTypeChange = (dataTypeValue) => {
    const value = getNewValue(inputValue, dataTypeValue);
    triggerOnChange(value);
  }

  const onValueChange = (e) => {
    const value = getNewValue(e.target.value, dataType);
    triggerOnChange(value);
  }

  const getDataTypeValue = (dataType) => {
    const option = options.filter(({ value }) => value === dataType);
    return option.length === 0 ? "" : option[0];
  }

  return (
    <InputGroup >
      <Input
        {...inputProps}
        disabled={isDisabled}
        value={inputValue}
        type={dynamicType}
        id={id}
        className={cx(
          {
            [styles.text_right]: true,
            className: className
          }
        )}
        onChange={(e) => onValueChange(e)} >
      </Input>
      <InputGroupText className={styles.weigth_input_group}>
        <SelectInput
          selectStyles={
            {
              control: (base) => ({
                ...base,
                backgroundColor: styles.weigth_input_group.background
              }),
            }
          }
          isDisabled={isDisabled}
          options={options}
          placeholder={false}
          value={getDataTypeValue(dataType)}
          defaultOption="lbs"//TODO
          onChange={(val) => onDataTypeChange(val)}
        />
      </InputGroupText>
      {inputErrors}
    </InputGroup>
  );
}

export default DynamicTypeInput;